import _merge from 'lodash/merge'
import React from 'react'
import { btoa, jsonStringify } from '@ztechapps/common.utils'

export type UseReportUrlProps = {
  url?: string
  query?: Record<string, any>
  fileName?: string
  accessToken?: string
}

export type UseReportUrlResult = {
  refreshUrl: (options: any) => void
  reportUrl: string
}
export const useReportUrl = ({ url, query, fileName, accessToken }: UseReportUrlProps): UseReportUrlResult => {
  const [reportUrl, setReportUrl] = React.useState('')
  const queryAsString = jsonStringify(query)

  const buildUrl = React.useCallback(
    ({ url, query, fileName, timeStamp = undefined }) => {
      const btoaResult = btoa({ accessToken, ...query, timeStamp })
      const _url = `${url}/${btoaResult}/${fileName}`
      setReportUrl(_url)
    },
    [accessToken, fileName, url, queryAsString]
  )

  const refreshUrl = React.useCallback(
    (options) => {
      const timeStamp = new Date().getTime()
      const mergeArgs = _merge({ url, query, fileName, timeStamp }, options)
      buildUrl(mergeArgs)
    },
    [buildUrl]
  )

  React.useEffect(() => {
    buildUrl({ url, query, fileName })
  }, [buildUrl])

  //TODO: Rename the refreshURL to refresh only
  return { refreshUrl, reportUrl }
}
